import React, { useState } from "react";
import CustomDiv from "../CustomDiv";
import brandLogo from "../../Assets/amaka.png";
import blogo from "../../Assets/blogo.svg";

import { Link, NavLink, useNavigate } from "react-router-dom";
import Text from "../Text";
import { useMutation, useQuery } from "react-query";
import { myWishList } from "../../Services/WishList";

import {
  Autocomplete,
  Box,
  Button,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  TextField,
  Typography,
} from "@mui/material";
import {
  ArrowBack,
  ExpandLess,
  ExpandMore,
  KeyboardArrowDownOutlined,
  MenuTwoTone,
} from "@mui/icons-material";
import { categoryListFn } from "../../Services/CategoryList";
import { useDispatch } from "react-redux";
import { setThemeMode } from "../../Redux/Actions/ThemeMode";
import { productsFn } from "../../Services/Products";
import DehazeIcon from "@mui/icons-material/Dehaze";
import SignIn from "../../Authentication/SignInPage";

const Headers = () => {
  const [open, setOpen] = useState(false);
  const [collapse, setCollapse] = useState([]);
  const [spices, setSpices] = React.useState([]);
  const { mutate: allProducts } = useMutation(productsFn, {
    onSuccess: (response) => {
      setSpices(response.data.data.product_list);
    },
  });

  React.useEffect(
    () => {
      allProducts();
    },
    // eslint-disable-next-line
    [""]
  );

  const products = spices.map((product) => {
    return {
      image: product.image,
      variant: product.variant_name,
      sub_category: product.sub_category,
      id: product.id,
    };
  });

  const handleClick = (id) => {
    setCollapse((collapse) => [...collapse, id]);
  };
  const handleClose = (id) => {
    setCollapse(collapse.filter((item) => item !== id));
  };
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { data } = useQuery(["wishList"], () => myWishList(), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const { data: mainCategoryList } = useQuery(
    ["mainCategoryList"],
    () => categoryListFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  const handleChange = (event) => {
    navigate(`/product/${event.currentTarget.lastChild.innerHTML}`);
    sessionStorage.clear();
    setOpen(false);
  };

  return (
    <>
      <div className="flex  w-full justify-center items-start bg-gradient-to-r from-white gap-5 to-blue-600 py-2  px-2">
        <Link to="/" className="">
          <img src={blogo} alt="" className="h-10 w-24" />
        </Link>
        <div className="flex justify-center items-center w-[100%]  ">
          <Autocomplete
            className="!bg-white  !rounded-md "
            options={products}
            autoHighlight
            size="small"
            freeSolo
            sx={{ width: "100%" }}
            onChange={handleChange}
            disableClearable
            getOptionLabel={(option) => option.variant}
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                <img
                  loading="lazy"
                  width="50"
                  src={option.image}
                  srcSet={option.image}
                  alt=""
                />
                <span className="flex flex-col">
                  <span className="text-lg">{option.variant}</span>
                  <span className="text-sm">{option.sub_category}</span>
                </span>

                <span id="variant_id" hidden>
                  {option.id}
                </span>
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Search Products"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "new-password", // disable autocomplete and autofill
                }}
              />
            )}
          />
        </div>
        <div className=" mt-2">
          {localStorage.getItem("shubhgatoken") ? (
            <NavLink to="/user-account">
              <DehazeIcon className="!text-white " />
            </NavLink>
          ) : (
            <SignIn className="text-white" />
          )}
        </div>
      </div>
    </>
  );
};

export default Headers;
